import { LockKeyhole } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { useAdminLogin } from '../../api/admin-queries.js';
import { ApiError } from '../../api/http.js';

const HTTP_TOO_MANY_REQUESTS = 429;

function loginErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.status === HTTP_TOO_MANY_REQUESTS)
    return 'Demasiados intentos fallidos. Espera unos minutos y vuelve a intentarlo.';
  if (error instanceof ApiError && error.status < 500) return 'Email o clave incorrectos.';
  return 'No pudimos iniciar sesión. Intenta de nuevo.';
}

export function AdminLoginForm() {
  const login = useAdminLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  function submit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    login.mutate({ email, password });
  }

  return (
    <form
      onSubmit={submit}
      className="mx-auto flex w-full max-w-sm flex-col gap-4 rounded-card border border-border bg-card p-6"
      aria-labelledby="admin-login-title"
    >
      <div className="flex items-center gap-2">
        <LockKeyhole aria-hidden="true" className="size-5 text-primary" />
        <h1 id="admin-login-title" className="text-xl font-bold">
          Administración
        </h1>
      </div>
      <p className="text-sm text-muted-foreground">
        Solo para el equipo de la distribuidora. Para comprar no necesitas cuenta.
      </p>
      <label className="flex flex-col gap-1">
        <span className="font-medium">Email</span>
        <input
          required
          type="email"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          autoComplete="username"
          className="min-h-11 rounded-control border border-border bg-card px-3"
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="font-medium">Clave</span>
        <input
          required
          type="password"
          value={password}
          onChange={(event) => {
            setPassword(event.target.value);
          }}
          autoComplete="current-password"
          className="min-h-11 rounded-control border border-border bg-card px-3"
        />
      </label>
      {login.isError && (
        <p role="alert" className="text-sm font-medium text-destructive">
          {loginErrorMessage(login.error)}
        </p>
      )}
      <button
        type="submit"
        disabled={login.isPending}
        className="min-h-11 cursor-pointer rounded-control bg-accent px-5 font-medium text-on-accent transition-opacity duration-150 hover:opacity-90 disabled:cursor-wait disabled:opacity-60"
      >
        {login.isPending ? 'Ingresando…' : 'Ingresar'}
      </button>
    </form>
  );
}
